var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFitToScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 14,
    viewBox: "0 0 27 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14810 -8021.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-14802.352,8024.8l-3.727,3.859,4,4.141",
    transform: "translate(1.078 -0.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-14805.807,8024.8l3.729,3.859-4,4.141",
    transform: "translate(13.578 -0.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-14809,8022v14",
    transform: "translate(0 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-14809,8022v14",
    transform: "translate(25 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-14809,8022v15",
    transform: "translate(-6767 22837) rotate(90)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitToScreen);
export default __webpack_public_path__ + "static/media/fit-to-screen.8f435fb6.svg";
export { ForwardRef as ReactComponent };